export default __webpack_public_path__ + "static/media/mission.b4c78f83.jpg";